module.exports = __webpack_public_path__ + "img/sweater.bae435ea.png";